define('challengeJs',['jquery','underscore','js-cookie'],function($, _, Cookies){

    var pendingIframe = false, pendingRequests = [];

    function unleashAllPendingRequests(){
        // request all pending queries
        pendingIframe = false;
        while(pendingRequests.length > 0){
            pendingRequests.pop()();
        }
    }

    // wrap a jQuery ajax Deferred to manage Challenge JS
    return function(settings){
        var tryChallenge = false;

        // Return a promise, so that you can chain methods
        // as you would with regular jQuery ajax calls
        return wrapAjax();

        function wrapAjax() {

            if(pendingIframe){
                // if iframe challengeJs resolution is pending, we don't feed more request to prevent WAF block
                // waiting for a resolution ...
                var defer = $.Deferred();
                pendingRequests.push(function(){
                    wrapAjax().done(function(data,textStatus,jqXHR){
                        defer.resolve(data,textStatus,jqXHR);
                    }).fail(function(jqXHR, textStatus, errorThrown){
                        defer.reject(jqXHR, textStatus, errorThrown);
                    });
                });
                return defer;
            }

            return $.ajax(settings).pipe(function(data, textStatus, jqXHR) {
                    // If it succeeds, don't keep retrying
                    return jqXHR;
                },function(jqXHR, textStatus, errorThrown) {
                    var text = jqXHR.responseText,
                        webfenceResponse = jqXHR.getResponseHeader('x-webfence-response'),
                        XCCSIdCookiePattern = /X-CCS-Id=(([a-zA-Z0-9_\-]+); path=\/)/;
                    if (textStatus === 'parsererror' && !tryChallenge && XCCSIdCookiePattern.test(text)) {
                        tryChallenge = true;
                        var Cookie = XCCSIdCookiePattern.exec(text)[2];
                        Cookies.set('X-CCS-Id',Cookie);
                        return wrapAjax();
                    } else if(webfenceResponse === 'challengejs'){
                        // si le challenge est présent,
                        var defer = $.Deferred();
                        pendingIframe = true;
                        // on créé un deferred en attendant de résoudre le challenge via une iframe
                        function onMessage(e){
                            var data = e.originalEvent.data;
                            if(!!data && (data.status === 'ok') && (data.type === 'ChallengeJS')){
                                // replay a totally new Ajax request
                                unleashAllPendingRequests();
                                $.ajax(settings).done(function(data,textStatus,jqXHR){
                                    defer.resolve(data,textStatus,jqXHR);
                                }).fail(function(jqXHR, textStatus, errorThrown){
                                    defer.reject(jqXHR, textStatus, errorThrown);
                                });
                            }
                        }
                        $(window).one('message',onMessage);
                        var iframe = document.createElement("iframe");
                        iframe.setAttribute('id','iframe-challenge-js');
                        // cette route est absolue /api/toolssecurity/challengejs
                        iframe.setAttribute('src','/api/toolssecurity/challengejs');
                        document.body.appendChild(iframe);
                        return defer;
                    } else {
                        return jqXHR;
                    }
                });
        }
    };
});
